export const getPriceFormat = (price: number): string => {
  try {
    return new Intl.NumberFormat('ru-RU').format(price);
  } catch (error) {
    return '';
  }
};
